import { TspType } from '../model/tsp.types'
import { getSingleTspType } from './getSingleTspType'

export const getTspListPathByTspType = (payee: { features?: { category_web?: string } }) => {
  switch (getSingleTspType(payee)) {
    case TspType.GAMES:
      return '/games'
    case TspType.SERVICES:
      return '/services'
    case TspType.KEYS:
      return '/keys'
    default:
      return '/'
  }
}
